// Constants for different requests for current reducer
export default {
  contacts: 'CONTACTS',
  contactInfo: 'CONTACT_INFO',
  updateContactForm: 'UPDATE_CONTACT_FORM',
  createContact: 'CREATE_CONTACT',
  updateContact: 'UPDATE_CONTACT',
  deleteContact: 'DELETE_CONTACT',
};
